<template>
  <div class="record-chart">
    <div class="record-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="warehouseCostChartRef"
        class="vxe-table-element"
        cell-class-name="multiple-select"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-config="canEdit ? {} : { trigger: 'click', mode: 'row' }"
        @edit-actived="editActivedEvent"
        :data="tableData"
        :edit-rules="tableRule"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <template v-slot:buttons>
          <el-button size="small" type="primary" class="vxe-btn-primary">仓储费率行信息</el-button>
          <el-button
            @click="$refs.warehouseCostChartRef.commitProxy('insert_actived')"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            v-if="showTableBtn"
            >新增</el-button
          >
          <el-button
            @click="deleteRowHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            v-if="showTableBtn"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'expenseCode'">仓储费</span>
            <span v-else-if="item.field == 'isSpecialLibrary'">{{
              getName('isSpecialLibrary', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commodityTypeCode'">{{
              row['commodityTypeName']
            }}</span>
            <span v-else-if="item.field == 'commodityCategoryCode'">{{
              getName('commodityCategory', row['commodityCategoryName'])
            }}</span>
            <span v-else-if="item.field == 'pricingStandard'">{{
              getName('pricingStandard', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'pricingUnit'">{{
              getName('pricingUnit', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'reservoirType'">{{
              getName('reservoirType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'packageCategoryName'">{{
              getName('packageCategoryName', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commodityClassificationCode'">{{
              getName('commodityClassificationCode', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commoditySpecificationsId'">
              {{ row['commoditySpecifications'] }}
            </span>
            <span v-else-if="item.field == 'packingId'">
              {{ row['pack'] }}
            </span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <el-input
              v-if="item.editRender.name == 'input'"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
            </el-input>
            <el-select
              v-else-if="item.editRender.name == 'expenseCode'"
              filterable
              clearable
              disabled
              value="1"
            >
              <el-option
                v-for="(i, index) in expenseList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commodityType'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => goodsTypeChange(row, val)"
            >
              <el-option
                v-for="(i, index) in goodsTypeList"
                :key="index"
                :label="i?.label"
                :value="i?.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commodityCategory'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => commodityCategoryChange(val, row, item.field)"
            >
              <el-option
                v-for="(i, index) in goodsCategoryList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commoditySpecificationsId'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => changecommoditySpecifications(val, row, '04')"
            >
              <el-option
                v-for="(i, index) in commoditySpecificationsList"
                :key="index"
                :label="i.name"
                :value="i.id"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commodityClassification'"
              filterable
              clearable
              :disabled="true"
              :value="commodityTypeCode"
            >
              <el-option
                v-for="(i, index) in commodityClassificationList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-input
              v-else-if="item.editRender.name == 'lowerTimeLimit'"
              :disabled="disabledTimeLimit"
              v-model="row[item.field]"
              placeholder="请输入"
            >
            </el-input>
            <el-input
              v-else-if="item.editRender.name == 'upperTimeLimit'"
              :disabled="disabledTimeLimit"
              v-model="row[item.field]"
              placeholder="请输入"
            >
            </el-input>
            <el-select
              v-else-if="item.editRender.name == 'packingId'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => changecommoditySpecifications(val, row, '05')"
            >
              <el-option
                v-for="(i, index) in packList"
                :key="index"
                :label="i.name"
                :value="i.id"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'pricingUnit'"
              :clearable="true"
              :filterable="true"
              autocomplete
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in pricingUnitOptions"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'pricingStandard'"
              :filterable="true"
              :clearable="true"
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => pricingStandardChange(row, val)"
            >
              <el-option
                v-for="(i, index) in pricingStandardList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'reservoirType'"
              :filterable="true"
              :clearable="true"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in reservoirTypeList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'packageCategoryName'"
              :filterable="true"
              :clearable="true"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in packageCategoryNameList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'isSpecialLibrary'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option value="1" label="是"></el-option>
              <el-option value="0" label="否"></el-option>
            </el-select>
            <search-table
              v-else-if="item.editRender.name == 'reservoirAreaName'"
              searchType="warehouse"
              :isMultiple="true"
              :extraData="{
                storageDepartmentCode: departmentCode,
                storageCompanyCode: companyCode,
              }"
              :disabled="canEdit"
              :currentValue="row.reservoirAreaName"
              @input="(val) => getWarehouse(val, row, item.field)"
            >
            </search-table>
            <input-number-ad
              v-else-if="item.editRender.name == 'lowerWeightLimit'"
              v-model="row.lowerWeightLimit"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              class="inputWidth"
              :disabled="disabledWeightLimit"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'upperWeightLimit'"
              v-model="row.upperWeightLimit"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              class="inputWidth"
              :disabled="disabledWeightLimit"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'unitPrice'"
              v-model="row.unitPrice"
              :controls="false"
              :min="0"
              :max="999999999"
              :disabled="canEdit"
              :precision="4"
              :clearable="true"
              class="inputWidth"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'minimumAmount'"
              v-model="row.minimumAmount"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              :disabled="canEdit"
              class="inputWidth"
              maxlength="10"
            ></input-number-ad>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  import goodsMixins from '../../../mixins/goodsMixins';
  export default {
    name: 'warehouseCostChart',
    mixins: [goodsMixins],
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      showTableBtn: {
        type: Boolean,
        default: true,
      },
      isDisabled: {
        type: Boolean,
        default: true,
      },
      goodsType: {
        type: Array,
        default: () => [],
      },
      commodityTypeCode: {
        type: String,
        default: '',
      },
      goodsCategoryRow: {
        type: Array,
        default: () => [],
      },
      commodityClassificationRow: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        canEdit: false,
        disabledTimeLimit: true, //控制时间上下限能否编辑
        disabledWeightLimit: true, //控制重量上下限能否编辑
        columns: [],
        goodsTypeList: [],
        goodsCategoryList: [],
        pricingStandardList: [],
        goodsCategoryAll: [],
        pricingUnitList: [],
        pricingUnitOptions: [],
        expenseList: [],
        reservoirTypeList: [], //库区类型
        packageCategoryNameList: [], //包装类别
        departmentCode: '',
        companyCode: '',
        ids: [],
        tableRule: {
          // commodityTypeCode: [
          //   { required: true, message: '商品类型必填', trigger: ['change', 'blur'] },
          // ],
          reservoirAreaName: [
            { required: true, message: '库区名称必填', trigger: ['change', 'blur'] },
          ],
          pricingStandard: [
            { required: true, message: '计价标准必填', trigger: ['change', 'blur'] },
          ],
          pricingUnit: [{ required: true, message: '计价单位必填', trigger: ['change', 'blur'] }],
          unitPrice: [{ required: true, message: '单价必填', trigger: ['change', 'blur'] }],
        },
        commodityClassificationList: [],
        commodityClassificationName: '',
      };
    },
    mounted() {
      this.columns = chartColumns(this);
      this.pricingStandardList = this.dictListMap.warehousePricingStandard;
      this.pricingUnitList = this.dictListMap.warehousePricingUnit;
      this.expenseList = this.dictListMap.warehouseExpenseName;
      this.reservoirTypeList = this.dictListMap.warehouseContractWarehouseType;
      this.packageCategoryNameList = this.dictListMap.warehouseContractPackageType;
      this.departmentCode = this.userInfo.departmentCode;
      this.companyCode = this.userInfo.companyCode;
    },
    methods: {
      // 选中行
      handleSelectionChange({ selection }) {
        this.selectionList = selection;
      },
      // 删除处理函数
      deleteRowHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.selectionList = [];
      },
      // 货物类型切换时更新级联的下拉数据
      async goodsTypeChange(row, val) {
        console.log(row, val, 'row-val');
        let commodityTypeNameList = this.goodsTypeList.filter((item) => val.includes(item.value));
        row.commodityTypeName = commodityTypeNameList
          .map((item) => {
            return item.label;
          })
          ?.join(',');
        row.commodityTypeId = commodityTypeNameList.map((item) => {
          return item.id;
        });
        console.log(row.commodityTypeName, 'row.commodityTypeName');
        row.commodityCategoryName = '';
        row.commodityCategoryCode = null;
        row.detailProductItems = null;
        this.updateCategory(row);
      },
      // 规格，包装改变时
      changecommoditySpecifications(val, row, attrType) {
        if (val.length) {
          if (attrType == '04') {
            let commoditySpecificationsList = [];
            this.commoditySpecificationsList.map((item) => {
              if (val.includes(item.id)) {
                commoditySpecificationsList.push(item.name);
              }
            });
            row.commoditySpecifications = commoditySpecificationsList.join(',');
          } else {
            let packlist = [];
            packlist = this.packList
              .filter((item) => val.includes(item.id))
              ?.map((item) => {
                return item.name;
              });
            row.pack = packlist.join(',');
          }
        } else {
          row.commoditySpecifications = '';
          row.pack = '';
        }
      },
      // 货物品类选择时更新货物规格
      commodityCategoryChange(val, row) {
        console.log(val, row, 'val-row');
        const itemList = this.goodsCategoryAll.filter((item) =>
          val.includes(item.productDetailCode)
        );
        let commodityCategoryNameList = [];
        let commoditySpecificationsList = [];
        let detailProductItemsList = [];
        let detailProductPacksList = [];
        if (itemList?.length) {
          itemList.map((item) => {
            if (item.productChName) commodityCategoryNameList.push(item.productChName);
            if (item.detailProductModelId) commoditySpecificationsList.push(item);
            if (item.detailProductItems) detailProductItemsList.push(item.detailProductItems);
            if (item.detailProductPacksId) detailProductPacksList.push(item);
          });
        }
        row['commodityCategoryName'] = commodityCategoryNameList.length
          ? commodityCategoryNameList.join(',')
          : '';
        row['commoditySpecificationsList'] = commoditySpecificationsList;
        row['detailProductPacksList'] = detailProductPacksList;
        row['detailProductItems'] = detailProductItemsList.length
          ? detailProductItemsList.join(',')
          : '';
      },
      // 根据选择的货物类型更新货物品类下拉
      updateCategory(row) {
        console.log(row);
        const goodsType = row.commodityTypeCode;
        if (goodsType?.length) {
          const item = this.goodsCategoryAll.filter((item) =>
            goodsType.includes(item.productParentCode)
          );
          console.log('item', item);
          if (item.length !== 0) {
            this.goodsCategoryList = item.map((item) => {
              if (item.productDetailCode) {
                return {
                  ...item,
                  value: item.productDetailCode,
                  label: item.productChName,
                };
              }
            });
          }
        }
      },
      // 表格行激活时处理函数
      editActivedEvent({ row }) {
        // 获取规格、包装列表
        this.focusHandler(row, '04'); //规格
        this.focusHandler(row, '05'); //包装
        this.updateCategory(row);
        this.pricingUnitOptions = this.filterUtil(row.pricingStandard);
        row.expenseName = '仓储费';
        row.expenseCode = '1';
        row.commodityClassificationCode = this.commodityTypeCode;
        row.commodityClassification = this.commodityClassificationList.find((item) => {
          item.value == row.commodityClassificationCode;
        })?.label;
      },
      // 得到指定仓库
      getWarehouse(val, row, field) {
        row[field] = val ? val[0].storageName : null;
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.warehouseCostChartRef;
          const tableData = $table.getTableData().fullData;
          console.log(tableData, '表格数据');
          $table.validate((valid) => {
            console.log(tableData, '表格数据', valid);
            if (valid) {
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  departmentCode: this.userInfo.departmentCode,
                  departmentName: this.userInfo.departmentName,
                  companyCode: this.userInfo.companyCode,
                  companyName: this.userInfo.companyName,
                  parkCompany: this.userInfo.companyName,
                  parkCompanyCode: this.userInfo.companyCode,
                  businessDepartmentCode: this.userInfo.departmentCode,
                  commodityCategoryCode: item.commodityCategoryCode?.length
                    ? item.commodityCategoryCode.join(',')
                    : '',
                  commodityTypeCode: item.commodityTypeCode?.length
                    ? item.commodityTypeCode.join(',')
                    : '',
                  commoditySpecificationsId: item.commoditySpecificationsId?.length
                    ? item.commoditySpecificationsId.join(',')
                    : '',
                  packingId: item.packingId?.length ? item.packingId.join(',') : '',
                };
              });
              resolve({ tableData: formTableData });
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [] });
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.warehouseCostChartRef;
        return $table.getTableData().fullData;
      },
      // 替换显示表格中value为label
      getName(type, value) {
        if (value == null || value == '') {
          return;
        }
        let item;
        if (type == 'commodityType') {
          if (!this.goodsTypeList.length || value == null || value == '') {
            return value;
          }
          item = this.goodsTypeList
            .filter((item) => value.includes(item?.value))
            .map((item) => {
              return item.label;
            });
          return item?.length ? item.join(',') : '';
        } else if (type == 'commodityCategory') {
          if (!this.goodsCategoryAll.length || value == null || value == '') {
            return value;
          }
          // item = this.goodsCategoryAll.find((item) => item.productDetailCode == value);
          return value;
        } else if (type == 'pricingStandard') {
          if (!this.pricingStandardList.length) {
            return value;
          }
          item = this.pricingStandardList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'pricingUnit') {
          if (!this.pricingUnitList.length) {
            return value;
          }
          item = this.pricingUnitList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'isSpecialLibrary') {
          item = [
            { value: 1, label: '是' },
            { value: 0, label: '否' },
          ].find((item) => item.value == value);
          return item?.label;
        } else if (type == 'reservoirType') {
          if (!this.reservoirTypeList.length) {
            return value;
          }
          item = this.reservoirTypeList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'packageCategoryName') {
          if (!this.packageCategoryNameList.length) {
            return value;
          }
          item = this.packageCategoryNameList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'commodityClassificationCode') {
          if (!this.commodityClassificationList.length) {
            return value;
          }
          item = this.commodityClassificationList.find((item) => item.value == value);
          return item?.label;
        }
      },
      // 填充表格信息
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 筛选计价单位
      filterUtil(fieldValue) {
        if (fieldValue == 'time') {
          // 时间
          return this.pricingUnitList.filter((item) => ['yuan_time'].includes(item.value));
        } else if (fieldValue == '02') {
          // 一口价
          return this.pricingUnitList.filter((item) => ['14'].includes(item.value));
        } else if (fieldValue == '03') {
          // 重量
          return this.pricingUnitList.filter((item) => ['07', '08'].includes(item.value));
        } else if (fieldValue == '04') {
          // 数量
          return this.pricingUnitList.filter((item) => ['09', '10', '11'].includes(item.value));
        } else if (fieldValue == '05') {
          // 车次
          return this.pricingUnitList.filter((item) => ['12', '13'].includes(item.value));
        } else if (fieldValue == 'day') {
          // 按天数
          return this.pricingUnitList.filter((item) =>
            ['yuan_ton', 'yuan_ge', 'yuan_che', 'years_ton', 'month_ton'].includes(item.value)
          );
        }
      },
      // 选择计价标准事件
      pricingStandardChange(row, val) {
        row.pricingUnit = null;
        row.upperTimeLimit = null;
        row.lowerTimeLimit = null;
        row.lowerWeightLimit = null;
        row.upperWeightLimit = null;
        if (val == 'time') {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = false;
        } else if (val == '03') {
          this.disabledTimeLimit = true;
          this.disabledWeightLimit = false;
        } else if (val == 'day') {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = false;
        } else {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = true;
        }
        this.pricingUnitOptions = this.filterUtil(val);
      },
      // 表单商品类别变化时， 更改表格商品信息
      goodsTypeChage() {
        if (!this.canEdit && this.$refs.warehouseCostChartRef.getTableData().fullData.length) {
          const tableData = this.$refs.warehouseCostChartRef.getTableData().fullData;
          tableData.forEach((item) => {
            item.commodityTypeCode = null;
            item.commodityCategoryCode = null;
            item.commoditySpecificationsId = null;
            item.detailProductItems = null;
          });
          this.tableData = tableData;
        }
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.tableData = val.map((item) => {
              return {
                ...item,
                commodityCategoryCode: item.commodityCategoryCode
                  ? item.commodityCategoryCode.split(',')
                  : [],
                commodityTypeCode: item.commodityTypeCode ? item.commodityTypeCode.split(',') : [],
                commoditySpecificationsId: item.commoditySpecificationsId?.length
                  ? item.commoditySpecificationsId.split(',')
                  : [],
                packingId: item.packingId?.length ? item.packingId.split(',') : [],
              };
            });
          }
        },
        immediate: true,
        deep: true,
      },
      isDisabled: {
        handler(val) {
          if (this.$route.query?.pageMode !== 0) {
            this.canEdit = val;
          }
        },
        immediate: true,
      },
      goodsType: {
        handler(val) {
          this.goodsTypeList = val;
          console.log('this.goodsTypeList', this.goodsTypeList);
        },
      },
      commodityTypeCode: {
        handler(val) {
          console.log('监听到商品类型变化', val);
          this.commodityClassificationName = this.commodityClassificationList.find(
            (item) => item.value == val
          )?.label;
          this.productCategoryId = this.commodityClassificationList.find(
            (item) => item.value == val
          )?.id;
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
      ::v-deep .multiple-select {
        .vxe-cell {
          max-height: fit-content;
        }
      }
    }
  }
</style>
